import { Box, Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { SyncIssue } from 'modules/integrations/public'

interface Props {
  issues: SyncIssue[]
}

const Unavailable = ({ issues }: Props) => {
  return (
    <Box gap="s16">
      {issues.map((issue, index) => (
        <Callout
          key={index}
          type="critical"
          title={issue.title}
          description={issue.description}
          link={
            issue.buttonUrl ? (
              <Button onClick={() => window.open(issue.buttonUrl, '_blank')}>
                {issue.buttonLabel}
              </Button>
            ) : issue.onAction ? (
              <Button onClick={issue.onAction}>{issue.buttonLabel}</Button>
            ) : undefined
          }
        />
      ))}
    </Box>
  )
}

export default Unavailable
